<script lang="ts">
	import { siteTitle } from '$lib/stores/nav';
	import { onMount } from 'svelte';

	export let data;

	onMount(() => {
		$siteTitle = 'Impressum';
	});
</script>

<div class="mt-4">
	<h1 class="text-4xl mb-10">Impressum</h1>

	<section class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7">
		<p class="col-span-2">
			Wenngleich die Crowdsourcingplattform nach ihrem Grundkonzept eine gemeinsame
			Kooperation zwischen dem Museum und der Wienbibliothek im Rathaus ist, so erfolgt das
			Transkriptionsprojekt „Kochbücher“ ohne Involvierung der Wienbibliothek im Rathaus. Das
			Impressum für das Transkriptionsprojekt „Kochbücher“ lautet:
		</p>
	</section>

	<section class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7">
		<div class="rte lg:col-start-2">
			<p>
				Medieninhaber:<br />
				Museen der Stadt Wien<br />
				Karlsplatz 8<br />
				1040 Wien
			</p>
			<p>
				T: +43 (0)1 505 87 47<br />
				E: office@wienmuseum.at
			</p>
			<p>
				Rechtsform: wissenschaftliche Anstalt öffentlichen Rechts<br />
				Firmenbuchnummer: FN 623 783d<br />
				Firmenbuchgericht: Handelsgericht Wien
			</p>
		</div>
	</section>

	<section
		class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7 border-t"
	>
		<h2>Design und Programmierung</h2>
		<div class="rte">
			<p>
				<a href="https://astridfeldner.com/" target="_blank" rel="noreferrer"
					>Astrid Feldner</a
				>,
				<a href="https://bleed.com" target="_blank" rel="noreferrer">Bleed Design Studio</a
				><br />
				<a href="https://urbantrout.io" target="_blank" rel="noreferrer">Urban Trout</a>
				(Harald Atteneder)<br />
				<a href="https://emptygraphics.com/" target="_blank" rel="noreferrer"
					>Empty Graphics</a
				> (Nikolaus Wettstein)
			</p>
		</div>
	</section>
</div>
